/**
 * splide.js
 */
import $ from "jquery";
import Drupal from "Drupal";
import drupalSettings from "drupalSettings";
import Splide from '@splidejs/splide';


(function ($, Drupal, drupalSettings) {

  'use strict';

  Drupal.behaviors.splide = {

    attach: function (context, settings) {

      once('loadSplide', 'section.splide', context).forEach(

        function(element){

          var id = $(element).attr('id');

          if($(element).hasClass('splide-popup'))
          {

          }
          else
          {
                var splide = new Splide( '#'+id, {
                                              type   : 'loop',
                                              padding: '10rem',
                                              autoWidth: true,
                                              focus: 'center'
                                            } );

                splide.mount();

                $(element).find('.field--name-field-media-image').click({cursplide:splide,id:id},function(e){



                    $(this).closest('.saipem--container').find('.splide-popup-container').show();
                    $('body').addClass('modal-open');

                    var zoomsplide = new Splide( '#'+e.data.id+'-popup', {
                                                                    type       : 'loop',
                                                                    pagination : true,
                                                                    arrows     : true,
                                                                    cover      : true,
                                                                    // fixedHeight : window.innerHeight,
                                                                    start : e.data.cursplide.index,
                                                                    pagination: false,
                                                                } );
                                                    zoomsplide.mount();

                });

                $(element).closest('.saipem--container').find('.splide-popup-close').click(function(e){
                    e.preventDefault();
                    $('body').removeClass('modal-open');
                    $(document).find('.splide-popup-container').hide();
                });
          }
        }
      );
    }

  }
})(jQuery, Drupal, drupalSettings);
